import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type LoadRecord = QueryAtomResult<typeof loadListAtom>[number];
export type BookingRecord = QueryAtomResult<typeof bookingListAtom>[number];
export type SalesOrderRecord = QueryAtomResult<
  typeof salesOrderListAtom
>[number];

export type ObjectRecord = LoadRecord | SalesOrderRecord | BookingRecord;

export const loadListAtom = createQueryAtomFactory(
  'chat.loadList',
  (params: { searchTerm?: string; ids?: string[] }) => ({
    loads: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
        },
        pagination: {
          limit: params.ids?.length ?? 30,
          offset: 0,
        },
      },
      entries: {
        id: true,
        status: true,
        documentNumber: true,
        expectedShipDate: true,
        organization: {
          id: true,
          name: true,
        },
        salesOrder: {
          account: {
            name: true,
          },
        },
      },
    },
  }),
  {
    select: ({ loads }) =>
      loads.entries.map((entry) => ({
        id: entry.id,
        status: entry.status,
        documentNumber: entry.documentNumber,
        expectedShipDate: entry.expectedShipDate,
        accountName: entry.salesOrder?.account?.name,
      })) ?? [],
  },
);
export const salesOrderListAtom = createQueryAtomFactory(
  'chat.salesOrderList',
  (params: { searchTerm?: string; ids?: string[] }) => ({
    salesOrders: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
        },
        pagination: {
          limit: params.ids?.length ?? 30,
          offset: 0,
        },
      },
      entries: {
        id: true,
        documentNumber: true,
        type: true,
        status: true,
        counterpartyReferenceNumber: true,
        account: {
          id: true,
          name: true,
        },
      },
    },
  }),
  {
    select: ({ salesOrders }) =>
      salesOrders.entries.map((entry) => ({
        id: entry.id,
        documentNumber: entry.documentNumber,
        type: entry.type,
        status: entry.status,
        counterpartyReferenceNumber: entry.counterpartyReferenceNumber,
        accountName: entry.account?.name,
      })) ?? [],
  },
);

export const bookingListAtom = createQueryAtomFactory(
  'chat.bookingList',
  (params: { searchTerm?: string; ids?: string[] }) => ({
    bookings: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
        },
        pagination: {
          limit: params.ids?.length ?? 30,
          offset: 0,
        },
      },
      entries: {
        id: true,
        status: true,
        documentNumber: true,
        destinationPort: {
          name: true,
        },
      },
    },
  }),
  {
    select: ({ bookings }) =>
      bookings.entries.map((entry) => ({
        id: entry.id,
        status: entry.status,
        bookingNumber: entry.documentNumber,
        destinationPortName: entry.destinationPort?.name,
      })) ?? [],
  },
);
